/**
 * Helper for opening external URLs (Stripe checkout, etc.)
 * 
 * In a browser, redirect normally with window.location.href.
 * In Capacitor native app, open the system browser so external
 * services like Stripe work correctly with their return URLs.
 */
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Open an external URL. Uses system browser on native, 
 * window.location.href on web.
 */
export const openExternalUrl = async (url) => {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
  } else {
    window.location.href = url;
  }
};
